class BorosilMainBlog extends HTMLElement {
  constructor() {
    super();
    this.activeChip = null;
    this.blogChips = [];
    this.blogHeader = null;
    this.blogLists = [];
    this.blogList = null;
  }

  connectedCallback() {
    this.blogChips = this.querySelectorAll(".main-blog__header-blog-chip");
    this.blogHeader = this.querySelector(".main-blog__header");
    this.blogLists = this.querySelectorAll(".marmeto-blog-list");
    this.blogList = this.querySelector(".main-blog__blog-list");

    this.blogHeader
      .querySelectorAll(
        ".main-blog__header-title, .main-blog__header-description"
      )
      .forEach((el) => (el.style.display = "none"));
    this.init();
    this.querySelector(".main-blog__header-blog-chips").addEventListener(
      "click",
      this.handleChipClick.bind(this)
    );
    this.updateUrl();
  }

updateUrl() {
  const activeBlog = this.activeChip?.dataset.blog;
  if (activeBlog) {
    const baseUrl = window.location.origin + window.location.pathname.replace(/\/tagged\/[^/]+/, '');
    const newUrl = `${baseUrl}/tagged/${activeBlog}`;
    if (window.location.href !== newUrl) {
      window.history.replaceState({}, '', newUrl);
    }
  }
}



  disconnectedCallback() {
    this.querySelector(".main-blog__header-blog-chips").removeEventListener(
      "click",
      this.handleChipClick.bind(this)
    );
  }

  init() {
    const storedActiveChip = localStorage.getItem("activeChip");

    if (storedActiveChip) {
      this.activeChip = this.querySelector(
        `.main-blog__header-blog-chip[data-title="${storedActiveChip}"]`
      );
    } else {
      this.activeChip = this.blogChips[0];
    }

    this.blogChips.forEach((chip) => chip.classList.remove("active"));

    if (this.activeChip) {
      this.activeChip.classList.add("active");
      this.updateDisplay();
    }
  }

  updateDisplay() {
    this.hideAllElements();
    this.updateHeaderContent();
    this.showArticleForActiveChip();
    this.showBlogListForActiveChip();
  }

  hideAllElements() {
    this.blogList
      .querySelectorAll(".main-blog__first-article-card")
      .forEach((article) => (article.style.display = "none"));
    this.blogLists.forEach((list) => (list.style.display = "none"));
  }

  showArticleForActiveChip() {
    if (this.activeChip) {
      const blogBlockId = this.activeChip.getAttribute("data-title");
      const articleBlock = this.blogList.querySelector(
        `[data-title="${blogBlockId}"]`
      );
      if (articleBlock) {
        articleBlock.style.display = "block";
      }
    }
  }

  showBlogListForActiveChip() {
    if (this.activeChip) {
      const blogBlockId = this.activeChip.getAttribute("data-title");
      const matchingBlogList = this.querySelector(
        `.marmeto-blog-list[data-title="${blogBlockId}"]`
      );
      if (matchingBlogList) {
        matchingBlogList.style.display = "block";
      }
    }
  }

  updateHeaderContent() {
    this.blogHeader
      .querySelectorAll(
        ".main-blog__header-title, .main-blog__header-description"
      )
      .forEach((el) => (el.style.display = "none"));
    const newTitle = this.activeChip.getAttribute("data-title");
    const newDescription = this.activeChip.getAttribute("data-description");

    if (newTitle && newDescription) {
      const titleEl = this.blogHeader.querySelector(".main-blog__header-title");
      const descriptionEl = this.blogHeader.querySelector(
        ".main-blog__header-description"
      );

      titleEl.textContent = newTitle;
      descriptionEl.textContent = newDescription;

      titleEl.style.display = "block";
      descriptionEl.style.display = "block";
    }
  }

  handleChipClick(event) {
    if (
      event.target &&
      event.target.classList.contains("main-blog__header-blog-chip")
    ) {
      this.blogChips.forEach((chip) => chip.classList.remove("active"));
      event.target.classList.add("active");
      this.activeChip = event.target;

      localStorage.setItem(
        "activeChip",
        this.activeChip.getAttribute("data-title")
      );

      this.updateDisplay();
      this.updateUrl();
    }
  }
}

customElements.define("borosil-main-blog", BorosilMainBlog);
